import React from "react";
import { motion } from "framer-motion";
import { Calendar, Sparkles } from "lucide-react";

export default function About() {
  return (
    <section id="sobre" className="py-24 lg:py-32 bg-muted/40 relative overflow-hidden" data-testid="about-section">
      <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-gradient-to-br from-[#00AEEF]/8 via-[#EC008C]/6 to-[#FF7F00]/6 blur-3xl pointer-events-none" />

      <div className="relative w-full px-5 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center"
        >
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-2xl border border-border bg-card shadow-[0_28px_70px_-28px_rgba(10,31,68,0.4)]">
              <img
                src="/images/ecoption-store-interior.webp"
                alt="Interior da loja Ecoption Supply em Guimarães"
                className="aspect-[4/3] w-full object-cover"
                loading="lazy"
                decoding="async"
                width="1800"
                height="1350"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1F44]/55 via-transparent to-transparent pointer-events-none" />

              <div className="absolute left-4 top-4 sm:left-5 sm:top-5 inline-flex items-center gap-2 rounded-full border border-white/60 bg-white/90 backdrop-blur-md px-3.5 py-1.5 text-xs font-medium text-[#0A1F44] shadow-sm">
                <Calendar size={12} className="text-[#00AEEF]" />
                Desde 2005 · Portugal
              </div>

              <div className="absolute bottom-4 left-4 sm:bottom-5 sm:left-5 rounded-xl border border-white/30 bg-white/95 backdrop-blur-md px-5 py-4 shadow-xl">
                <div className="font-display text-4xl sm:text-5xl font-bold leading-none cmyk-text">20+</div>
                <div className="mt-1 text-sm font-semibold text-[#0A1F44]">anos de experiência</div>
              </div>
              <div className="absolute inset-x-0 bottom-0 h-1 cmyk-gradient" />
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-8 lg:border-l border-border">
            <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground font-semibold mb-4">
              Sobre nós
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] font-semibold text-foreground tracking-tight leading-[1.1]" data-testid="about-title">
              Novo nome. Mesma confiança.
            </h2>
            <div className="mt-7 space-y-5 text-base lg:text-lg text-muted-foreground leading-relaxed">
              <p>
                A <span className="font-semibold text-foreground">Ecoption Supply representa uma nova etapa, construída a partir do conhecimento e da experiência adquiridos no setor e da passagem de testemunho da Ecopção</span>,
                marca que esteve presente durante mais de duas décadas no mercado português
                de consumíveis e soluções de impressão.
              </p>
              <p>
                Com uma nova estrutura e identidade, a Ecoption Supply dá continuidade a esse
                conhecimento, apostando na proximidade, fiabilidade, poupança e numa resposta
                ágil às necessidades de empresas e instituições.
              </p>
            </div>

            <div className="mt-9 inline-flex items-center gap-2 text-sm font-medium text-foreground">
              <Sparkles size={14} className="text-[#064E3B]" />
              <span className="font-semibold text-[#064E3B]">Ecopção</span>
              <span className="text-muted-foreground">→</span>
              <span className="cmyk-text font-semibold">Ecoption Supply</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
